import React from 'react';
import { Crosshair, LocateFixed, X } from 'lucide-react';
import { ETAPA_LABELS, ESTADO_LABELS } from './PointCard';

const Sel = ({ value, onChange, children, tid, label }) => (
  <label className="flex flex-col gap-1 min-w-0">
    <span className="text-[11px] text-slate-500">{label}</span>
    <select value={value} onChange={e => onChange(e.target.value)} className="input-base text-sm py-1.5" data-testid={tid}>{children}</select>
  </label>
);

const RADIOS = [30, 50, 100, 200];

const DistanceFilter = ({ distancia, setDistancia, onUseLocation, onPickOnMap, picking }) => (
  <div className="flex flex-col gap-1 col-span-2 min-w-0">
    <span className="text-[11px] text-slate-500">Distancia en línea recta desde un punto</span>
    <div className="flex flex-wrap items-center gap-1.5">
      <button type="button" onClick={onUseLocation} className="btn-secondary text-xs px-2 py-1.5 flex items-center gap-1" data-testid="distance-use-location">
        <LocateFixed className="w-3.5 h-3.5" /> Mi ubicación
      </button>
      <button type="button" onClick={onPickOnMap} className={`btn-secondary text-xs px-2 py-1.5 flex items-center gap-1 ${picking ? 'ring-2 ring-blue-400' : ''}`} data-testid="distance-pick-map">
        <Crosshair className="w-3.5 h-3.5" /> {picking ? 'Pulsa en el mapa…' : 'Elegir en mapa'}
      </button>
      {distancia.origen && (
        <>
          <select value={RADIOS.includes(distancia.km) ? distancia.km : 'custom'} onChange={e => setDistancia({ ...distancia, km: e.target.value === 'custom' ? (RADIOS.includes(distancia.km) ? 75 : distancia.km) : Number(e.target.value) })} className="input-base text-xs py-1.5" style={{ width: "auto" }} data-testid="distance-radius">
            {RADIOS.map(r => <option key={r} value={r}>{r} km</option>)}
            <option value="custom">Personalizada</option>
          </select>
          {!RADIOS.includes(distancia.km) && (
            <input type="number" min="1" max="2000" value={distancia.km} onChange={e => setDistancia({ ...distancia, km: Math.max(1, Number(e.target.value) || 1) })} className="input-base text-xs py-1.5" style={{ width: "5rem" }} data-testid="distance-custom-km" />
          )}
          <button type="button" onClick={() => setDistancia({ origen: null, km: 50 })} className="text-slate-400 hover:text-slate-700" title="Quitar filtro de distancia" data-testid="distance-clear"><X className="w-4 h-4" /></button>
        </>
      )}
    </div>
  </div>
);

export const MapFilters = ({ f, setF, options, mediadores, showMediador, distancia, setDistancia, onUseLocation, onPickOnMap, pickingDistance }) => {
  const set = (k) => (v) => setF(prev => ({ ...prev, [k]: v }));
  return (
    <div className="grid grid-cols-2 sm:grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-2 items-end" data-testid="map-filters">
      <label className="flex flex-col gap-1 col-span-2 sm:col-span-1 min-w-0">
        <span className="text-[11px] text-slate-500">Buscar</span>
        <input value={f.search} onChange={e => set('search')(e.target.value)} placeholder="NPL, dirección, RC…" className="input-base text-sm py-1.5" data-testid="map-filter-search" />
      </label>
      {showMediador && (
        <Sel label="Mediador" value={f.mediador} onChange={set('mediador')} tid="map-filter-mediador">
          <option value="">Todos</option>
          {mediadores.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
        </Sel>
      )}
      <Sel label="Estado" value={f.estado} onChange={set('estado')} tid="map-filter-estado">
        <option value="">Activos (por defecto)</option>
        {Object.entries(ESTADO_LABELS).filter(([k]) => k !== 'papelera').map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </Sel>
      <Sel label="Fase" value={f.etapa_visual} onChange={set('etapa_visual')} tid="map-filter-fase">
        <option value="">Todas</option>
        {Object.entries(ETAPA_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </Sel>
      <Sel label="Tipo operativo" value={f.tipo_activo_operativo} onChange={set('tipo_activo_operativo')} tid="map-filter-tipo">
        <option value="">Todos</option>
        <option value="CREDITO">Crédito</option>
        <option value="SUBASTA">Subasta</option>
        <option value="REMATE">Remate</option>
        <option value="OCUPADO">Ocupado</option>
        <option value="REO">REO</option>
        <option value="COMPRA_DIRECTA">Compra Directa</option>
        <option value="sindatos">Sin datos</option>
      </Sel>
      <Sel label="Provincia" value={f.provincia} onChange={set('provincia')} tid="map-filter-provincia">
        <option value="">Todas</option>
        {(options.provincias || []).slice().sort().map(p => <option key={p} value={p}>{p}</option>)}
      </Sel>
      <label className="flex flex-col gap-1 min-w-0">
        <span className="text-[11px] text-slate-500">Municipio</span>
        <input value={f.municipio} onChange={e => set('municipio')(e.target.value)} list="map-municipios" placeholder="Todos" className="input-base text-sm py-1.5" data-testid="map-filter-municipio" />
        <datalist id="map-municipios">{(options.municipios || []).slice(0, 3000).map(m => <option key={m} value={m} />)}</datalist>
      </label>
      <DistanceFilter distancia={distancia} setDistancia={setDistancia} onUseLocation={onUseLocation} onPickOnMap={onPickOnMap} picking={pickingDistance} />
    </div>
  );
};

export default MapFilters;
